import React from "react";
import UserFoldersAdmin from "../components/UserFoldersAdmin/UserFoldersAdmin";

const UserFoldersAdminPage = () => {
  return (
      <UserFoldersAdmin />
   
  );
};

export default UserFoldersAdminPage;
